export default [
  {
    name: 'main',
    path: '/',
    meta: {
      design: { classes: ['bg--linear-gradient'] },
    },
    beforeEnter(to, from, next) {
      next()
    },
    component() {
      return import('@/pages/main/Main.vue')
    },
  },
]
